export default function StarIcon({ size = 50, isActive = false, onClick }) {
  return (
    <svg
      width={size}
      height={size}
      onClick={onClick}
      viewBox="0 0 50 51"
      fill={isActive ? "#198c39" : "#EEEEEE"}
      xmlns="http://www.w3.org/2000/svg"
      data-active={isActive}
    >
      <path d="M24.0766 6.88594C24.4182 6.06465 25.5817 6.06465 25.9233 6.88594L30.794 18.5966L43.4367 19.6102C44.3234 19.6813 44.6829 20.7878 44.0073 21.3664L34.375 29.6176L37.3178 41.9547C37.5242 42.8199 36.5829 43.5038 35.8238 43.0401L25 36.4289L14.1761 43.0401C13.417 43.5038 12.4757 42.8199 12.6821 41.9547L15.625 29.6176L5.99258 21.3664C5.31704 20.7878 5.67657 19.6813 6.56323 19.6102L19.2059 18.5966L24.0766 6.88594Z" />
    </svg>
  );
}
